import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  standalone: false,
  template: `<router-outlet></router-outlet><ks-toast-container></ks-toast-container>`,
})
export class AppComponent {}
